import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=3a3126c6&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=3a3126c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3126c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SnackbarComponent: require('/home/hitaxi/domains/app.hitaxivipairport.com/front-end/components/SnackbarComponent.vue').default})
